import { IconButton, Box, Typography } from "@mui/material";
import PaymentsIcon from "@mui/icons-material/Payments";
import { Menu } from "@mui/material";
import { styles } from "./menu.style";
import { auth } from "../../config/firebase";
import { useEffect, useState } from "react";

const CreditStatusButton = ({
  handleCreditClick,
  credits,
  creditAnchorEl,
  handleCreditClose,
}) => {
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid);
      } else {
        setUserId(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const renderStripeButtons = () => {
    if (!userId) return null;
    return (
      <>
        <Box sx={styles.stripeButtonContainer}>
          <stripe-buy-button
            key={`button-3-${userId}`}
            buy-button-id="buy_btn_1RSPKGC5u6C4QjGjeqBdYWuV"
            publishable-key="pk_live_51RMBY7C5u6C4QjGj42uF4tTBO97OI8vqNF9DJX7W9fMv2CSyrTKb11jvvgUbPvrXVXJVmoROtOQExgmNfDUcoKDE00XuzdfyVM"
            client-reference-id={userId}
          />
        </Box>
        <Box sx={styles.stripeButtonContainer}>
          <stripe-buy-button
            key={`button-4-${userId}`}
            buy-button-id="buy_btn_1RSPLfC5u6C4QjGjjn9qhHQm"
            publishable-key="pk_live_51RMBY7C5u6C4QjGj42uF4tTBO97OI8vqNF9DJX7W9fMv2CSyrTKb11jvvgUbPvrXVXJVmoROtOQExgmNfDUcoKDE00XuzdfyVM"
            client-reference-id={userId}
          />
        </Box>
      </>
    );
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleCreditClick}
        aria-controls="credit-menu"
        aria-haspopup="true"
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <PaymentsIcon />
          <Typography variant="body2" sx={{ ml: 0.5 }}>
            {credits}
          </Typography>
        </Box>
      </IconButton>
      <Menu
        id="credit-menu"
        anchorEl={creditAnchorEl}
        keepMounted
        open={Boolean(creditAnchorEl)}
        onClose={handleCreditClose}
        PaperProps={{
          sx: styles.creditMenuPaper,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={styles.creditBalanceContainer}>
            <Typography variant="h6" sx={styles.creditBalanceTitle}>
              Credit Balance
            </Typography>
            <Box sx={styles.creditBalanceContent}>
              <PaymentsIcon sx={styles.creditIcon} />
              <Typography variant="h6" sx={styles.creditBalanceAmount}>
                {credits}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              ...styles.creditCostContainer,
            }}
          >
            <Typography variant="h7" sx={{ flex: 2 }}>
              Credit Cost per Report Type
            </Typography>
            <Box sx={{ flex: 3 }}>
              <ul>
                <li>
                  <strong>Name Ideation</strong>: 1
                </li>
                <li>
                  <strong>Trademark</strong>: 1
                </li>
                <li>
                  <strong>Domain</strong>: 1
                </li>
                <li>
                  <strong>Full</strong>: 3
                </li>
              </ul>
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {renderStripeButtons()}
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default CreditStatusButton;
